export default __webpack_public_path__ + "static/char-35-anr-b9cbf1cf7f6086e115af58a9f694c731.gif";